export default "__VITE_ASSET__4a880242__"